"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**Mezcla una definición de una columna con una función de estilo, dandole prioridad al estilo original de las columnas */
function mixStyle(columm, style) {
    return Object.assign({}, columm, { cell: (row) => {
            const ret = columm.cell(row);
            const retStyleFunc = ret.style || (() => ({}));
            return Object.assign({}, ret, { style: (itemData) => (Object.assign({}, style(row, itemData), retStyleFunc(itemData))) });
        } });
}
/**Le agrega un estilo a todas las celdas de un arreglo de Grid2Column. Si la celda ya define su propio estilo, este es mezclado con el estido dado por la funcion
 * rowStyle con el operador spread (...), dandole prioridad a las propiedades del estilo definido por la celda
 */
function applyRowStyleToColumns(columns, rowStyle) {
    return columns.map(col => mixStyle(col, rowStyle));
}
exports.applyRowStyleToColumns = applyRowStyleToColumns;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/gridOps.js
// module id = 2234
// module chunks = 0